<template>
  <section class="dp-layout">

    <section class="dp-left">
      <DepartmentPane
        :key="treeDirectoryScope"
        :directory-scope="treeDirectoryScope"
        :pane-title="treePaneTitle"
        @tree-node-click="treeNodeClick"
      ></DepartmentPane>
    </section>

    <section class="dp-right">

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="学生退款记录" name="0">
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

          <!-- 列表：tbl-scroll-host + height 保证空状态可见。最后更新：2026-08-31 -->
          <div class="tbl-scroll-host">
          <el-table height="100%" :data="refundRecords" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
            ref="table" style="width: 100%" class="custom-tbl">
            <el-table-column prop="Id" label="退款ID" width></el-table-column>
            <el-table-column prop="UserName" label="用户名" width></el-table-column>
            <el-table-column prop="DepartmentName" label="部门名称" width></el-table-column>
            <el-table-column prop="TotalAmount" label="退款金额" width></el-table-column>
            <el-table-column prop="RefundDetail" label="退款详情" width>
              <template slot-scope="scope">
                <span v-if="scope.row.RefundDetail" style="color: var(--btn-primary, #2563eb); cursor: pointer; text-decoration: underline;"
                      @click="showRefundDetail(scope.row.RefundDetail)">
                  查看详情
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="退款时间" width></el-table-column>
            <el-table-column prop="Remarks" label="备注" width></el-table-column>
          </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="教师退款记录" name="1">
          <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>
          <div class="tbl-scroll-host">
          <el-table height="100%" :data="refundRecords" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow"
            ref="table" style="width: 100%" class="custom-tbl">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="Id" label="退款ID" width></el-table-column>
            <el-table-column prop="UserName" label="用户名" width></el-table-column>
            <el-table-column prop="DepartmentName" label="部门名称" width></el-table-column>
            <el-table-column prop="TotalAmount" label="退款金额" width></el-table-column>
            <el-table-column prop="RefundDetail" label="退款详情" width>
              <template slot-scope="scope">
                <span v-if="scope.row.RefundDetail" style="color: var(--btn-primary, #2563eb); cursor: pointer; text-decoration: underline;"
                      @click="showRefundDetail(scope.row.RefundDetail)">
                  查看详情
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="退款时间" width></el-table-column>
            <el-table-column prop="Remarks" label="备注" width></el-table-column>
          </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>
    </section>

    <!-- 退款详情弹窗 -->
    <el-dialog title="退款详情" :visible.sync="refundDetailVisible" width="45%" center>
      <div v-if="refundDetailList && refundDetailList.length > 0" style="padding: 10px 0;">
        <el-table :data="refundDetailList" border style="width: 100%" class="detail-table">
          <el-table-column prop="RefundNo" label="退款单号" width=""></el-table-column>
          <el-table-column prop="OutTradeNo" label="支付订单号" width=""></el-table-column>
          <el-table-column prop="TradeNo" label="支付外部订单" width=""></el-table-column>
          <el-table-column prop="TotalAmount" label="订单总金额" width=""></el-table-column>
          <el-table-column prop="RefundAmount" label="订单退款金额" width=""></el-table-column>
        </el-table>
      </div>
      <div v-else>
        暂无退款详情
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refundDetailVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getRefundList, exportRefundList } from '../../api/modules/consumption';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      refundDetailVisible: false, // 退款详情弹窗显示状态
      refundDetailList: [], // 退款记录列表
      activeName: "0",
      filters: {
      },
      searchList: [
        {
          label: '用户名',
          key: 'name',
        },
        {
          label: '开始日期',
          key: 'date',
          type: 'date'
        },
        {
          label: '结束日期',
          key: 'endDate',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      refundRecords: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: ""
    };
  },
  computed: {
    /** 学生=家校，教师=内部通讯录。最后更新：2026-09-04 */
    treeDirectoryScope() {
      return String(this.activeName) === "1" ? "internal" : "teaching";
    },
    treePaneTitle() {
      return this.treeDirectoryScope === "internal" ? "内部通讯录" : "家校通讯录";
    },
  },
  methods: {
    // 显示退款详情弹窗
    showRefundDetail(refundDetail) {
      try {
        // 清空之前的数据
        this.refundDetailList = [];
        
        // 尝试将字符串转换为JSON对象
        if (typeof refundDetail === 'string') {
          refundDetail = JSON.parse(refundDetail);
        }
        
        // 判断是否为数组
        if (Array.isArray(refundDetail)) {
          this.refundDetailList = refundDetail;
        } else {
          // 如果不是数组，将其作为单个元素的数组
          this.refundDetailList = [refundDetail];
        }
        console.log(this.refundDetailList);
        // 打开弹窗
        this.refundDetailVisible = true;
      } catch (e) {
        console.error('解析退款详情失败:', e);
        this.refundDetailList = [{ RefundNo: refundDetail }];
        this.refundDetailVisible = true;
      }
    },

    handleClick(tab, event) {
      this.page = 1;
      this.DepartmentId = "";
      this.refundRecords = [];
      this.total = 0;
      // 切 Tab 后由部门树 :key 重载并自动选中节点触发查询
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
        type: this.activeName // 使用userType参数区分学生/教师
      };
      this.listLoading = true;
      //NProgress.start();
      getRefundList(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.refundRecords = res.data.response.data;
        this.listLoading = false;
        //NProgress.done();
      });
    },

    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };

        var fileName = this.activeName == 0 ? "学生退款记录" : "教师退款记录";
        const response = await exportRefundList(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

.detail-table {
  margin-bottom: 15px;
}
</style>